import { computed } from 'mobx';
import { BaseSite, type AppCapabilities } from '@link/share/stores';
import siteApi from '@link/shop/services/endpoints/site';

export class Site extends BaseSite implements AppCapabilities {
  readonly columnPlanAutoSwitch = true;
  readonly profilePostCodeEnabled = true;
  readonly capacityNotice = true;
  readonly lastMonthSoldOut = true;
  readonly voucherPdf = true;
  readonly requireFormName = true;

  protected get siteApi() {
    return siteApi;
  }

  @computed
  get supportCart() {
    return this.siteSchema?.siteLayout?.supportCart;
  }

  @computed
  get logoUrl() {
    return this.siteSchema?.siteLayout?.headerConfig?.logoUrl;
  }
}

export default new Site();
